var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('ManagePhonesTable')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('section',[_c('ManageScannersTable')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('section',[_c('ManageSimTable')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1adb9fdc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Manage/ManageDevices.vue
// module id = null
// module chunks = 